import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {
  inject,
  Inject,
  Injectable,
  makeStateKey,
  Optional,
  PLATFORM_ID,
  RESPONSE_INIT,
  TransferState
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { RESPONSE } from "../../../../express.tokens";
import { Response } from 'express';
import { EnvService } from "@gea-waldviertler-website/shop-lib";
import { ServerErrorService } from "../../server-error.service";

export const SSR_API_UNAVAILABLE_KEY = makeStateKey<boolean>('ssr_api_unavailable')

/**
 * Behandelt einen 503 der gea-api.
 *
 * Beim SSR wird der Status an die express-Response durchgereicht, damit eine
 * server-gerenderte Seite nicht mit Status 200 ausgeliefert wird, wenn das
 * Backend nicht verfügbar war.
 *
 * Im Browser gibt es keine Response zu setzen - dort wird statt eines Toasts
 * app-weit die ServerErrorComponent eingeblendet.
 */
@Injectable()
export class Response503Interceptor implements HttpInterceptor {
  private envService = inject(EnvService)

  private platformId = inject(PLATFORM_ID)

  private serverErrorService = inject(ServerErrorService)

  private transferState = inject(TransferState)

  constructor(
    @Optional() @Inject(RESPONSE) private response?: Response,
    @Optional() @Inject(RESPONSE_INIT) private responseInit?: ResponseInit | null,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // nur gea-api-Requests auswerten
    if (! (request.url.startsWith(this.envService.config.apiURL) || request.url.startsWith(this.envService.config.apiURL_SSR))) {
      return next.handle(request)
    }

    // Response mit Status 500-599 = error
    return next.handle(request).pipe(tap({
      error: (error: unknown) => {
        if (! (error instanceof HttpErrorResponse) || (error.status !== 0 && (error.status < 500 || error.status > 599))) return

        if (isPlatformBrowser(this.platformId)) {
          if (this.transferState.get(SSR_API_UNAVAILABLE_KEY, false)) return

          this.serverErrorService.show()
          return
        }

        this.transferState.set(SSR_API_UNAVAILABLE_KEY, true)
        this.response?.status(503)
        if (this.responseInit) {
          this.responseInit.status = 503
        }
      }
    }))
  }
}
